import { Button } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import { PageAlert } from 'BrokerTsLib/src/components'
import type { FlexGroup, UpdateFlexGroup } from 'BrokerTsLib/src/dtos'
import { useFlexGroup } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { useNavigate, useParams } from 'react-router'

import { Loading } from '@/components'
import { DashboardHeader, DashboardHeaderBackButton } from '@/containers/dashboard/DashboardHeader'
import { FlexGroupForm } from '@/containers/flex-group/FlexGroupForm'
import { Refresh } from '@/icons'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Breadcrumbs } from 'BrokerTsLib/src/containers/Breadcrumbs'

export const FlexGroupEditPage = () => {
  const navigate = useNavigate()
  const { flexGroupId: flexGroupIdParam } = useParams()
  const flexGroupId = parseInt(flexGroupIdParam ?? '')

  const { flexGroup, updateAsync, isError, isLoading, refetch } = useFlexGroup(flexGroupId)

  const onSubmit = (data: UpdateFlexGroup) =>
    updateAsync(data)
      .then((response) => {
        navigate(`/flex-group/${flexGroupId}`)
        return response
      }) as Promise<FlexGroup | AxiosError>

  return isError ?
    <PageAlert status="error" title="Chyba při načítání stránky">
      <Button colorScheme="red" isLoading={isLoading} onClick={() => refetch()}><Refresh /> Obnovit stránku</Button>
    </PageAlert>
    :
    <PageWrapper
      header={<>
        <Breadcrumbs items={[
          { to: '/flex-group/list', label: 'Seznam flexibilních skupin' },
          { to: `/flex-group/${flexGroupId}`, label: flexGroup?.name ?? 'Flexibilní skupina' },
          { to: `/flex-group/${flexGroupId}`, label: 'Upravit', current: true }
        ]} />
        <DashboardHeader title='Upravit flexibilní skupinu'>
          <DashboardHeaderBackButton onClick={() => navigate(`/flex-group/${flexGroupId}`)}>Zpět na flexibilní skupinu</DashboardHeaderBackButton>
        </DashboardHeader>
      </>}
      mainProps={{
        sx: {
          pt: { base: 0, sm: 8 },
          gap: 4,
          display: 'grid',
          w: { base: '100%', sm: 'md' },
          margin: '0 auto',
        }
      }}
    >
      {isLoading ? <Loading /> : <FlexGroupForm flexGroup={flexGroup!} onSubmit={onSubmit} />}
    </PageWrapper>
}
